import { useState, useEffect } from 'react';
import styles from './PixelOverlay.module.css';

export default function PixelOverlay() {
  const [enabled, setEnabled] = useState(false);
  const [opacity, setOpacity] = useState(0.5);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('overlay') === '1') {
      setEnabled(true);
    }
  }, []);

  if (!enabled) return null;

  return (
    <>
      <img
        src="/screenshot.png"
        alt="Reference overlay"
        className={styles.overlay}
        style={{ opacity }}
      />
      <div className={styles.controls}>
        <label className={styles.label}>
          Overlay: {Math.round(opacity * 100)}%
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={opacity}
            onChange={(e) => setOpacity(parseFloat(e.target.value))}
            className={styles.slider}
          />
        </label>
        <button
          className={styles.closeBtn}
          onClick={() => setEnabled(false)}
        >
          Close
        </button>
      </div>
    </>
  );
}
